export const BACKEND = "https://pokedexbackend-production.up.railway.app";